class PopinVideo{

	constructor() {
		this.cross = document.querySelector('.popinVideo-cross')
		this.popin = document.querySelector('.popinVideo')

		if(this.popin !== null){
			this.init()
		}
	}

	init(){
		this.closePopin()
	}

	closePopin(){
		this.cross.addEventListener('click',()=>{
			this.popin.classList.add('popinVideo-close')
		})
	}
}

module.exports = PopinVideo;
